<template>
  <div class="chart-legend">
    <div class="legend-item" v-for="(legend, index) in items" :key="legend.label + `_${index}`">
      <div class="marker" :class="[type, legend.class]"></div>
      <div class="label">{{legend.label}}</div>
    </div>
  </div>
</template>


<script>
/*
Usage: pass and array of legendItems


legendItem is
{
  'label': LABEL_VALUE
  'class': CLASS (optional)
}

type: ['line', 'dot']
*/
export default {
  name: 'ChartLegend',
  props: {
    'items': Array,
    'type': {
      type: String,
      default: 'dot'
    }
  },
}
</script>

<style  lang="stylus" scoped>
 .chart-legend
    display flex
    justify-content center
    margin-bottom vh(12px)
    margin-top vh(12px)
    z-index 5
    .legend-item
      display flex
      align-items center
      &:not(:last-child)
        margin-right vw(28px)
      .marker
        display inline-block
        width 10px
        height 10px
        margin-right 4px
        background $bs-blue
        &.line
          height vw(2px)
          width vw(18px)
        &.dot
          border-radius 50%
        &.secondary
          background #B9B9B9
        &.sector-current
          background $bs-blue
        &.sector-all
          background #000
        &.compare
          background $compare-color
          &.secondary
            background #ebd2b2
      .label
        font-family: 'Lato'
        m-font-size(11,13)
        font-weight $fw-semi-bold
</style>